import { defineMessages } from 'react-intl';

export default defineMessages({
    tfpaMessage:{
        id: "twia-tfpa.views.manage-claims.Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by claim number, policy number, or mailing address.",
        defaultMessage: "Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by claim number, policy number, or mailing address."
    },
    twiaMessage:{
        id: "twia-tfpa.views.manage-claims.Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by claim number, policy number, or primary loss location.",
        defaultMessage: "Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by claim number, policy number, or primary loss location."
    },
    manageClaims:{
        id: "twia-tfpa.views.manage-claims.Manage Claims",
        defaultMessage: "Manage Claims"
    },
    fileAClaim:{
        id: "twia-tfpa.views.manage-claims.Click Here to file a claim",
        defaultMessage: "Click Here to File a New Claim"
    },
    noAuthoriziationHeader: {
        id: "twia-tfpa.views.manage-claims.No Authorization Notification Header",
        defaultMessage: "Account Expired"
    },
    noAuthoriziationMessage: {
        id: "twia-tfpa.views.manage-claims.No Authorization Notification Message",
        defaultMessage: "The account you are using has expired and will not properly display your information. You will need to register for a new account."
    },
    noAuthoriziationLink: {
        id: "twia-tfpa.views.manage-claims.No Authorization Notification Link",
        defaultMessage: "Learn more."
    },
})
